module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Settings-1-f851742b4c40c18e8ba6cd5962a18bda.svg";